import * as THREE from 'three'
import gsap from 'gsap'

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Object
const geometry = new THREE.BoxGeometry(1, 1, 1)
const material = new THREE.MeshBasicMaterial({ color: 0xff0000 })
const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh)

// Sizes
const sizes = {
    width: 800,
    height: 600
}

// Camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.z = 3
scene.add(camera)

// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)

// // Time
// let time = Date.now()

// // Clock
// const clock = new THREE.Clock()

// GSAP
gsap.fromTo(mesh.position,{x:-1}, {duration:1, x:1, repeat:-1, yoyo:true, ease:'expo.inOut'})

// Animation
const tick = () =>
{
    // // Clock
    // const elapsedTime = clock.getElapsedTime()
    
    // // Time
    // const currentTime = Date.now()
    // const deltaTime = currentTime-time
    // time = currentTime
    
    // Update objects
    // mesh.rotation.y += 0.001 * deltaTime
    // mesh.rotation.y = elapsedTime * Math.PI * 0.5
    // mesh.position.y = Math.sin(elapsedTime)
    // mesh.position.x = Math.cos(elapsedTime)

    // camera.lookAt(mesh.position)

    // Render
    renderer.render(scene, camera)

    window.requestAnimationFrame(tick)
}

tick()